// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"dbfa916c","183":"655ef50f","218":"fc7b7fd5","223":"2bba1b75","275":"9d1950e1","322":"087e320d","378":"ab54e9c1","409":"e07c3adc","453":"f700bfc1","538":"e7523435","584":"f1129e04","696":"b6558972","895":"92e14742","919":"d220f7a0"}[chunkId] + ".chunk.js";
};